import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMoneybag: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="moneybag, purse, savings"><path d="M9.42188 7.75H14.5781M9.42188 7.75C9.42188 7.75 3.74996 10.9722 3.75 16.1111C3.75003 20.2435 7.85366 21.25 12 21.25C16.1463 21.25 20.25 20.2435 20.25 16.1111C20.25 10.9722 14.5781 7.75 14.5781 7.75M9.42188 7.75L7.875 3.77778C7.875 3.77778 9.42188 2.75 12 2.75C14.5781 2.75 16.125 3.77778 16.125 3.77778L14.5781 7.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMoneybag;
